import { AutoFragment } from '@/graphql/fragments/public'
import { ClosingReasonFragment, ProcessStatusFragment } from '@/graphql/fragments/settings'
import gql from 'graphql-tag'

export const getPaymentOrdersQuery = gql`
  query DashboardsPaymentOrders($start_date: timestamp, $end_date: timestamp) {
    records: finance_payment_order(where: {created_at: {_gte: $start_date, _lte: $end_date}}) {
      id
      amount
      createdAt: created_at
      expenseCategory: expense_category {
        id
        name
        description
        color
      }
      items (limit: 1) {
        id
        processExpense: process_expense {
          id
          expense {
            id
            name
            description
            type {
              id
              name
              description
              color
              category {
                id
                name
                description
                color
              }
            }
          }
        }
      }
    }
  }
`

export const getExpensesQuery = gql`
  query DashboardPayments($start_date: timestamp!, $end_date: timestamp!) {
    records: finance_payment(where: {_and: [{id_payment_recipient: { _is_null: false }}, { closing_reason: { type: { name: { _eq: "successful" } } } }, {created_at: {_gte: $start_date, _lte: $end_date}}]}) {
      id
      amount
      createdAt: created_at
      paymentRecipient: payment_recipient {
        id
        paymentOrder: payment_order {
          id
          expenseCategory: expense_category {
            id
            name
            description
            color
          }
        }
      }
    }
  }
`

export const getExpensesFullQuery = gql`
  query DashboardExpensesFull($start_date: timestamp!, $end_date: timestamp!) {
    records: finance_payment(where: {_and: [{id_payment_recipient: { _is_null: false }}, { closing_reason: { type: { name: { _eq: "successful" } } } }, {created_at: {_gte: $start_date, _lte: $end_date}}]}) {
      id
      amount
      deal {
        id
        auto {
          id
          registrationPlate: registration_plate
          version: version_year {
            id
            year {
              id
            }
            version {
              id
              name
              model {
                id
                name
                brand {
                  id
                  name
                }
              }
            }
          }
        }
      }
      createdAt: created_at
      paymentRecipient: payment_recipient {
        id
        paymentOrder: payment_order {
          id
          person {
            id
            firstName: first_name
            surname
            alias
            type {
              name
              description
            }
          }
          items {
            id
            processExpense: process_expense {
              id
              expense {
                id
                name
                description
                type {
                  id
                  name
                  description
                  color
                  category {
                    id
                    name
                    description
                    color
                  }
                }
              }
            }
          }
          expenseCategory: expense_category {
            id
            name
            description
            color
          }
        }
      }
    }
  }
`

export const getDailyAccountBalance = gql`
  query DailyAccountBalance($start_date: date, $end_date: date) {
    records: finance_daily_account_balance(where: {date: {_gte: $start_date, _lte: $end_date}}) {
      id
      date
      accountBalance: account_balance
      availableBalance: available_balance
      bankAccount: bank_account {
        id
        accountNumber: account_number
        metadata
        bank {
          id
          alias
        }
      }
    }
  }
`

export const getPendingExpensesQuery = gql`
  query DashboardPendingExpenses {
    records: finance_payment(where: { _and: [{id_closing_reason: { _is_null: true }}, { id_payment_recipient: { _is_null: false}}] }) {
      id
      amount
      createdAt: created_at
      deal {
        id
        auto {
          id
          registrationPlate: registration_plate
          version: version_year {
            id
            year {
              id
            }
            version {
              id
              name
              model {
                id
                name
                brand {
                  id
                  name
                }
              }
            }
          }
        }
      }
      paymentRecipient: payment_recipient {
        id
        paymentOrder: payment_order {
          id
          person {
            id
            firstName: first_name
            surname
            alias
            type {
              name
              description
            }
          }
          items (limit: 1) {
            id
            processExpense: process_expense {
              id
              expense {
                id
                name
                description
                type {
                  id
                  name
                  description
                  color
                  category {
                    id
                    name
                    description
                    color
                  }
                }
              }
            }
          }
          expenseCategory: expense_category {
            id
            name
            description
            color
          }
        }
      }
    }
  }
`

export const getPendingFinancePayments = gql`
  ${ProcessStatusFragment}
  ${ClosingReasonFragment}
  query PendingFinancingPayment {
    records: finance_payment(where: {_and: {payment_type: {name: {_eq: "financing"}}, status: {status: {name: {_eq: "pending_payment"}}}}}) {
      id
      amount
      deal {
        id
        auto {
          id
          registrationPlate: registration_plate
          version: version_year {
            id
            year {
              id
            }
            version {
              id
              name
              model {
                id
                name
                brand {
                  id
                  name
                }
              }
            }
          }
        }
        stock {
          id
          soldDate: sold_date
        }
        saleOrders: sale_orders {
          id
          financings {
            id
            evaluations {
              id
              closingReason: closing_reason {
                ...ClosingReason
              }
              status {
                ...ProcessStatus
              }
              offers {
                id
                fee
              }
            }
          }
        }
      }
      payer {
        id
        alias
        metadata
      }
    }
  }
`
